import React from 'react'
import { useDispatch } from 'react-redux'
import { IconClose } from '../../../asset/icon/IconClose'
import { PdfIcon } from '../../../asset/icon/PdfIcon'
import { setModalSwitching } from '../../../store/actions/setting'
//@ts-ignore
import s from './SaveConfigLink.module.scss'

export const SaveConfigLink = () => {


    const dispatch = useDispatch()
    const onClose = () => {

        dispatch(setModalSwitching({ idModal: 'visibleSaveConfig', conditionModal: false }))
    }

    return (
        <div className={s.wrap}>
            <header>
                <div className={s.icon} onClick={() => onClose()}>
                    <IconClose />
                </div>
            </header>
            <div className={s.title}>Save configuration link</div>
            <div className={s.subtitle}>We will automatically generate a link to your configuration and send it to the provided email address</div>

            <form action="">
                <input type="text" placeholder="E-mail" />
                <button>Send</button>
            </form>

            <button className={`${s.btn_download}`}>
                <div className={s.icon}> <PdfIcon />  </div>
                <div className={s.name}>Download PDF</div>
            </button>
        </div>
    )
}
